// AUTO-GENERATED by scripts/version/stamp-app-version.mjs — do not edit by hand.
// This file is gitignored (see .gitignore) and regenerated by `postinstall`
// and again immediately before `build` / `build:dev` / `build:local` /
// `build:prod`, from the root package.json "version" field, so the Sentry
// `release` tag set via Sentry.init() (see src/main.ts) matches the release
// created by scripts/deploy.sh → upload_sentry_sourcemaps(), which reads the
// same root package.json version.
export const APP_VERSION = '1.32.1';
